
import React, { useState, useEffect, useRef, useContext } from 'react';
// import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import './App.css';
import { ethers } from 'ethers';
import $ from 'jquery';
import axios from 'axios';
// Page components
  import { connectWallet, switchNetwork, switchNavConnectButtonText, onboard, refreshAccountCenterWithoutPrompt } from './NavBar';
//   import { getDataForList } from './Browse';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';

// import ToggleButton from '@mui/material/ToggleButton';
// import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import HelpOutline from '@mui/icons-material/HelpOutline';
// import Typography from '@mui/material/Typography';
// import FormHelperText from '@mui/material/FormHelperText';

// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell, { tableCellClasses } from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';

// import copy from 'copy-to-clipboard';

///////// For virtualized search window
//   // import * as React from 'react';
//   import PropTypes from 'prop-types';
//   // import TextField from '@mui/material/TextField';
//   import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
//   import useMediaQuery from '@mui/material/useMediaQuery';
//   import ListSubheader from '@mui/material/ListSubheader';
//   import Popper from '@mui/material/Popper';
//   import { useTheme, styled } from '@mui/material/styles';
//   import { VariableSizeList } from 'react-window';
//   // import Typography from '@mui/material/Typography';
/////////

// import PsiTeams from './artifacts/contracts/PsiTeams.sol/PsiTeams.json';
import { ClosedCaptionDisabledSharp } from '@mui/icons-material';

// Smart contract address
    // const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;

// Set base URLs & IDs
    let USER_API_ENDPOINT_ROOT, PROVIDER_URL, ASSETS_FOLDER, NETWORK_CHAIN_ID, FAQ_URL;

    if (process.env.NODE_ENV === "development") {
        console.log("local environment");
        USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_LOCAL;
        PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_LOCAL;
        ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_LOCAL;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_LOCAL;
        FAQ_URL = process.env.REACT_APP_PSISCOPE_FAQ;   
    } else {
        console.log("production environment");
        USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_PRODUCTION;
        PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_PRODUCTION;
        ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_PRODUCTION;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_PRODUCTION;
        FAQ_URL = process.env.REACT_APP_PSISCOPE_FAQ;
    }

    // Switching functions list
        // 1) Alert switcher (switchAlert(_alert)) - helps change alert messages
        // 2) Main button switcher (mainButtonSwitcher(show)) - helps change main button text and function
        // 3) Password resetter (resetAllPasswordAlerts()) - reset all password alerts

let sendButtonDisabled = false;

// Get URL parameter (if included)
	function getURLParameter(_param) {
		let pageURL = window.location.search.substring(1);
		let URLVariables = pageURL.split('&');
		for (let i = 0; i < URLVariables.length; i++) {
			let parameterName = URLVariables[i].split('=');
			if (parameterName[0] == _param) {
				return decodeURIComponent(parameterName[1]);
			}
			if (i == (URLVariables.length - 1)) {
				return "empty";
			}
		}
	}

// Manage page reload
    async function selectivePageRefresh() {
        console.log("selectivePageRefresh called");
        // const currentURL = window.location.href;
        // const last3Chars = currentURL.slice(-3);
        // const pageId = last3Chars.toLowerCase();
        // console.log("Page id: " + pageId);
        // if (pageId == "ups" || pageId == "ps/" || pageId == "000" || pageId == "00/") {
        //   console.log("setupBlockchain should be triggered: " + pageId);
        //   setupBlockchain();
        // } else {
        //   console.log("Page should reload");
            window.location.reload();
        // }
		// ------------

		// setupBlockchain(); // added
    }

// Alert switcher
	export async function switchAlert(_alert) {

        console.log("switchAlert: " + _alert);
        let alertType = _alert;
		$('.alert-area').hide();

        if (alertType !== 'connect-blockchain') {
            console.log("Hide 'connect-blockchain'");
			$(".connect-blockchain").hide(300);
		} else {
            console.log("Show 'connect-blockchain'");
            // $(".connect-blockchain").show(300);
            setTimeout(function() {
                $(".connect-blockchain").show(300);
            }, 1400); // delay of 1.4 sec (important/precise)
        }

        if (alertType == 'swtich-network') {
			$(".swtich-network").show(300);
		}
		if (alertType == 'registered-user-edit') {
			$(".registered-user-edit").show(300);
		}
		if (alertType == 'new-user') {
			$(".new-user").show(300);
		}
		if (alertType == 'username-unavailable') {
			$(".username-unavailable").show(300);
		}
        if (alertType == 'email-unavailable') {
			$(".email-unavailable").show(300);
		}
        if (alertType == 'user-authentification-failed') {
			$(".user-authentification-failed").show(300);
		}
	}

// Proxied functions

    let proxy, inputLabelChange; // global
    function clearInputLabelsAndSetState() {
        let randomNumber = Math.random();
        proxy.inputLabelChange = randomNumber;
    }

    let proxy2, inputFieldsOpenTrigger; // global
    function openInputFields() {
        let randomNumber = Math.random();
        proxy2.inputFieldsOpenTrigger = randomNumber;
    }

// CHECK WALLET STATUS & SETUP BLOCKCHAIN * * * [Initially auto-triggered from Navbar] * * * *
    export async function setupBlockchain(previous_wallet = null) {
        let connected, trackSwitchAlert;
        let wrongChain = false;
        console.log("setupBlockchain triggered");

        // Check if wallet is installed
        if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
            // if wallet is installed...
            console.log("Wallet is installed");

            // Load account & check if user is connected
            const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
            const account = wallet_accounts[0];
            console.log("Detected wallet account: " + account);
            console.log('listenForAccountChanges triggered');
            await listenForAccountChanges();

            // If user is connected...
            if (typeof account !== "undefined") { 
                console.log("User account active: " + account);
                switchNavConnectButtonText(account); // imported from navbar
                
                // Check chain ID
                    let chainID = await window.ethereum.request({ method: 'eth_chainId' });
                    console.log('Chain ID: ' + chainID);
                // Monitor chain change
                    console.log("Listen for chain changes - 1");
                    await listenForChainChanges();
                    // Switch chain ID if needed...
                    if (chainID != NETWORK_CHAIN_ID) { 
                        console.log("Wrong chain:" + chainID);
                        wrongChain = true;
                        connected = false;
                        mainButtonSwitcher('switch');
                        // await switchAlert('connect-blockchain');
                        trackSwitchAlert = 'swtich-network';
                    } else {
                        console.log("User is all set");
                        connected = true;
                        sendButtonDisabled = false;
                        mainButtonSwitcher('verify');
                    }

                // Search for user's current name & email using blockchain address and, if found in DB, display them in input fields
                    if (trackSwitchAlert !== 'swtich-network') {
                        const userInfo = await getUserInfoFromDB(account, 'blockchain');
                        console.log("Retrieved user info: ", userInfo);
                        // User info found in DB...
                        if (userInfo !== "none") { 
                            console.log("Registered user");
                            $('.subheading').hide(200);
                            $('.update-mode').show(200);
                            $('.register-mode').hide();
                            $('#user-name-field').val(userInfo['username']);
                            // $('#user-email-field').val(userInfo['email']);
                            $('#user-email-field').val('[email hidden]');
                            clearInputLabelsAndSetState(); // using proxy
                            $('.id-table').show(300);
                            trackSwitchAlert = 'registered-user-edit';
                        // No user info found in DB...
                        } else if(userInfo === "none") { 
                            console.log("New user");
                            $('.subheading').hide(200);
                            $('.register-mode').show(200);
                            $('#user-name-field').val('');
                            $('#user-email-field').val('');
                            openInputFields(); // using proxy
                            mainButtonSwitcher('save');
                            trackSwitchAlert = 'new-user';
                        }
                    }

            } else {
                console.log("User is not connected");
                switchNavConnectButtonText("CONNECT WALLET"); // imported from navbar
                connected = false;
                mainButtonSwitcher('connect');
                // switchAlert('connect-blockchain');
                trackSwitchAlert = 'connect-blockchain';
            }
        } else {
            console.log("Wallet is not available");
            switchNavConnectButtonText("CONNECT WALLET"); // imported from navbar
            connected = false;
            mainButtonSwitcher('connect');
            // switchAlert('connect-blockchain');
            trackSwitchAlert = 'connect-blockchain';
        }

        console.log("User connected?: " + connected);
        if (previous_wallet == 'no-previous' && (connected == true || wrongChain == true )) {
            console.log('Need to activate Web3-Onboard');
            mainButtonSwitcher('connect');
            // switchAlert('connect-blockchain');
            trackSwitchAlert = 'connect-blockchain';
        }

        switchAlert(trackSwitchAlert);
        
        return connected;
    }


// Monitor wallet account changes
    export async function listenForAccountChanges() {
        // Check if wallet is installed
        if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
            console.log("Wallet is installed - listner");
            // Load account & check if user is connected
              const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
              console.log('wallet_accounts[0]: ' + wallet_accounts[0]);

              if (typeof wallet_accounts[0] !== "undefined") { 
                  console.log("User account active - listner: " + wallet_accounts[0]);
                  // Remove account change listner
                    console.log("Remove ALL wallet account change listners");
                    window.ethereum.removeAllListeners('accountsChanged');
                  // Set listner for account changes
                    console.log("Listen for wallet account changes - 1");
                    window.ethereum.on('accountsChanged', function (wallet_accounts) {
                        console.log("Account change detected - 1");
                        // setupBlockchain();
                        selectivePageRefresh();
                    })
              }
        }
    }

// Monitor chain changes
    export async function listenForChainChanges() {
        console.log("listenForChainChanges triggered - 0");
        setTimeout(function() {
          // Remove chain change listner
            console.log("Remove ALL chain change listners - 0");
            window.ethereum.removeAllListeners('chainChanged');
          // Monitor chain change
            console.log("Chain change listener set- 0");
            window.ethereum.on('chainChanged', onChainChanged);
        }, 1000); // delay of 1 sec
    }
    async function onChainChanged(chainId) {
        console.log("Chain change detected - 0");

        await refreshAccountCenterWithoutPrompt(onboard); // new 7/4/25
        selectivePageRefresh();
    }

// Main button switcher
    export function mainButtonSwitcher(show) {
        console.log("Main button switcher triggered");
        setTimeout(function() {
            $("#show-verify-button").hide();
            $("#save-button").hide();
            $("#connect-wallet-button").hide();
            $("#switch-chain-button").hide();
            $(".bchain-help-section").hide();
            if (show == "verify") { $("#show-verify-button").show(); }
            if (show == "save") { $("#save-button").show(); }
            if (show == "connect") { $("#connect-wallet-button").show(); }
            if (show == "switch") { $("#switch-chain-button").show(); }
            if (show != "save" && show != "verify") { $(".bchain-help-section").show(150); }

        }, 1000); // delay of 1 sec
    }

// Switch to different network 
    export async function handleSwitchNetwork() {
      try {
          console.log("Try switching network/chain");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: NETWORK_CHAIN_ID }],
          })
          setupBlockchain();
      } catch(err) {
          if (err.code === 4902) { // if network not found, add it
              connectWallet();
          } else {
              alert("Could not swtich to correct network!")
              $("#save-button").hide();
              $("#connect-wallet-button").show();
              $("#switch-chain-button").hide();
          }
      }
    }

// Create group key (packed hash)
    function makeKeyPacked(_index, _address) {
      let inputData = ethers.utils.solidityPack(['uint256', 'address'], [_index, _address]);
      let key = ethers.utils.keccak256(inputData);
      return key;
    }

// Request user's wallet address
    async function requestAccount() {
        console.log("requestAccount() triggered");
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const bc_account = accounts[0];
            return bc_account;
        } catch(err) {
            console.log("Error: ", err);
            $("#show-verify-button").show();
            $("#bchain-progress").hide();
            return "error";
        }
    }

// ----

// VERIFY blockchain address then get ONCHAIN user information from DB
async function authenticateUserAndGetInfoFromDB(_account) { // blockchain, blockchain-inc-private, email or username
    console.log("function authenticateUserAndGetInfoFromDB triggered * * * : " + _account);
    // Sign random message
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        const randomMessage = "This is a quick and standard 'Web3' way of verifying your identity. There are no transaction fees involved. Simply click 'sign' and the system will take care of the rest. Authentification code ('nonce'): " + Math.random().toString(36).substring(2);
        console.log("Check randomMessage: ", randomMessage);
        let userSignature;
        try {
            userSignature = await signer.signMessage(randomMessage);
        } catch(err) {
            console.log("Error: ", err);
            return "error";
        }
        console.log("Check userSignature: ", userSignature);

    return new Promise((resolve, reject) => {
        let postData = {
            type: 'query',
            query_type: 'latest',
            // key: "0x3C44CdDdB6a900fa2b585dd299e03d12FA4293BC",
            key: _account, // blockchain, email or username
            key_type: 'blockchain-inc-private', // 'email', 'bockchain', 'blockchain-inc-private', 'username', 'combined'
            message: randomMessage,
            signature: userSignature
        };
        axios({ 
            url: USER_API_ENDPOINT_ROOT + "user-registry.php",
            method: "POST",
            data: JSON.stringify(postData),
        })
        .then((res) => { 
            const returned_data = JSON.parse(res.data.data);
            console.log("Check returned_data (user-registry): ", returned_data);
            resolve(returned_data);
        }) 
        .catch((err) => { 
            console.log("error response: ", err);
        });
    });
}

//----


// Get ONCHAIN user information from DB
    async function getUserInfoFromDB(_key, _keyType) { // blockchain, blockchain-inc-private, email or username
        console.log("function getUserInfoFromDB triggered * * * : " + _key + ", " + _keyType);
        return new Promise((resolve, reject) => {
            let postData = {
                type: 'query',
                query_type: 'latest',
                key: _key, // blockchain, email or username
                key_type: _keyType // 'email', 'bockchain', 'blockchain-inc-private', 'username', 'combined'
            };
            axios({ 
                url: USER_API_ENDPOINT_ROOT + "user-registry.php",
                method: "POST",
                data: JSON.stringify(postData),
            })
            .then((res) => { 
                const returned_data = JSON.parse(res.data.data);
                console.log("Check returned_data (user-registry): ", returned_data);
                resolve(returned_data);
            }) 
            .catch((err) => { 
                console.log("error response: ", err);
            });
        });
    }

// Get OFFCHAIN user information from user_registry_offchain DB
	export async function getUserInfoFromDB_offchain(_key, _keyType) { // username or email address
		console.log("function getUserInfoFromDB_offchain triggered * * * : " + _key + ", " + _keyType);

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'query',
				query_type: 'latest',
				key: _key, // username or email address
				key_type: _keyType // 'username', 'email', or 'combined'
			};
			axios({ 
				url: USER_API_ENDPOINT_ROOT + "user-registry-offchain.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = JSON.parse(res.data.data);
				console.log("Check returned_data (user-registry-offchain): ", returned_data);
				resolve(returned_data);
			}) 
			.catch((err) => { 
				console.log("error response: ", err);
			});
		});
	}


// Check user password against offchain DB

    export async function checkUserPassword(_username, _password) {

        console.log("checkUserPassword triggered - - -");
        console.log("Check _password: " + _password);
        return new Promise((resolve, reject) => {
            let postData = {
                type: 'password_check',
                username: _username,
                password: _password
            };
            axios({ 
                url: USER_API_ENDPOINT_ROOT + "user-registry-offchain.php",
                method: "POST",
                data: JSON.stringify(postData),
            })
            .then((res) => { 
                const returned_data = res.data; // 'valid' or 'invalid'
                console.log("checkUserPassword returned_data (user-registry-offchain): ", returned_data);
                resolve(returned_data);
            }) 
            .catch((err) => { 
                console.log("error response: ", err);
            });
        });
    }



/////////////////////

function App() {

    // State variables
        // const navigate = useNavigate();
		// const [publicDisplayMode, setPublicDisplayMode] = useState(false);
		// const [copyText, setCopyText] = useState('Get Public URL');

        const [inputIsDisabled, setInputIsDisabled] = useState(true);
        // const [editMode, setEditMode] = useState(false); 

        const [existingUserAddress_state, setExistingUserAddress] = useState(null);
        const [existingUsername_state, setExistingUsername] = useState(null);

        const [errorUsername, setErrorUsername] = useState(false);
        const [errorEditAddresses, setErrorEditAddresses] = useState(false);
        const [errorUserEmail, setErrorUserEmail] = useState(false);
        const [errorUserPassword, setErrorUserPassword] = useState(false);
		
		const [rejectedUsersString_state, setRejectedUsersString] = useState(null);

        const [usernameLabel_state, setUsernameLabel] = useState('Public Username');
        const [userEmailLabel_state, setUserEmailLabel] = useState('Email Address');
        const [userPasswordLabel_state, setUserPasswordLabel] = useState('Password');

        const [username_tb_state, setUsername_tb_state] = useState(null);
        const [userEmail_tb_state, setUserEmail_tb_state] = useState(null);

        const [userAddress_state, setUserAddr] = useState(null);
        const [username_state, setUsername] = useState(null);
        const [userEmail_state, setUserEmail] = useState(null);
        const [userPassword_state, setUserPassword] = useState(null);

        const [passwordFieldVisible, setPasswordFieldVisible] = useState(false);

        const [enableTableEdit, setEnableTableEdit] = useState(true);

        const [dense, setDense] = useState(false);

        // Reset page
            function handleNavbarResetClick() {
                console.log("Call resetWallet");
                window.location.reload();
            }

        // Get user blockchain address on page load [no longer in use]
            useEffect(() => {
                // async function setInitialAddress() {
                //     const bchain_account = await requestAccount();
                //     setUserAddr(bchain_account);
                // }
                // setInitialAddress(); 
            }, []);

        // PROXY #1 - Keep track of inputLabelChange via proxy
            // Proxy handler
            let proxyHandler = {
                set: async function(target, property, value) {
                target[property] = value;
                // On variable change...
                    const bchain_account = await requestAccount();
                    setUserAddr(bchain_account);

                    // setEmailInputIsDisabled(true);
                    setInputIsDisabled(true); // added 6/14

                    setUsernameLabel('');
                    setUserEmailLabel('');
                    const nameInputValue = $('#user-name-field').val();
                    const emailInputValue = $('#user-email-field').val();
                    setUsername(nameInputValue);
                    setUserEmail(emailInputValue);
                    setUsername_tb_state(nameInputValue);
                    setUserEmail_tb_state(emailInputValue);
                    return true;
                }
            };
        // Create a proxied variable which triggers above function on change
            proxy = new Proxy({ inputLabelChange: inputLabelChange }, proxyHandler);

        // PROXY #2 - Keep track of inputFieldsOpenTrigger via proxy
            // Proxy handler
            let proxyHandler2 = {
                set: async function(target, property, value) {
                target[property] = value;
                // On variable change...
                    setInputIsDisabled(false);
                    const bchain_account = await requestAccount();
                    setUserAddr(bchain_account);
                    // setUsernameLabel('');
                    // setUserEmailLabel('');
                    return true;
                }
            };
        // Create a proxied variable which triggers above function on change
            proxy2 = new Proxy({ inputFieldsOpenTrigger: inputFieldsOpenTrigger }, proxyHandler2);

	// Reset for Edit mode
		// function resetForEdit() {
		// 	//
		// }

    // Make sure input fields are not empty

		async function checkInputFields() {

			console.log('checkInputFields triggered * * *');
			console.log("Check username_state", username_state);
			console.log("Check userEmail_state", userEmail_state);
            console.log("Check userPassword_state", userPassword_state);

			let valid = true;

            if (username_state) { 
                console.log("Check 1");
                setErrorUsername(false);
            } else { 
                console.log("Check 2");
                setErrorUsername(true); 
                valid = false; }

            if (userEmail_state) { 
                setErrorUserEmail(false);
            } else { 
                setErrorUserEmail(true); 
                valid = false; }

			console.log("Check valid: " + valid);

			const result = {
				valid: valid
			}
			return result;
		}

    // Insert user info to registry

      async function insertUserInfo(_update_type, _username, _bchain_address, _email, _version_num = 1) {
        console.log("function insertUserInfo triggered");
        console.log("Check _update_type: " + _update_type);
        console.log("Check _username: " + _username);
        console.log("Check _bchain_address: " + _bchain_address);
        console.log("Check _email: " + _email);
        console.log("Check _version_num: " + Number(_version_num));

        return new Promise((resolve, reject) => {
          let postData = {
              type: 'insert', // 'insert' or 'query'
              update_type: _update_type, // 'original' or 'update'
              username: _username,
              bchain_address: _bchain_address, 
              email: _email,
              version_num: _version_num
          };
          axios({ 
              url: USER_API_ENDPOINT_ROOT + "user-registry.php",
              method: "POST",
              data: JSON.stringify(postData),
          })
            .then((res) => { 
                const returned_data = JSON.parse(res.data);
                console.log("Check returned_data: ", returned_data);
                if (returned_data !== 'error') {
                  resolve(returned_data);
                } else { 
                  console.log("Could not insert data to DB!");
                  resolve(null); 
                }
            }) 
            .catch((err) => { 
                console.log("error response: ", err);
            });
        });
      }

    // Reset all password alerts (including username alert & password state variable)
        function resetAllPasswordAlerts() {
            $(".username-unavailable-offchain").hide(300);
            $(".password-invalid-offchain").hide(300);
            setUserPassword(null);
            setErrorUsername(false);
            setErrorUserPassword(false);
            setPasswordFieldVisible(false);
        }

    // Check & handle password (triggered when username already exists in OFFchain DB)

        async function handlePassword() {

            if (userPassword_state !== null) { // If password has already been entered by user...

                console.log("handlePassword - Password entered");
                // Check if password is correct
                let passwordCheckResult = await checkUserPassword(username_state, userPassword_state);
                console.log("passwordCheckResult: " + passwordCheckResult);

                // If password is INVALID, stop txn, alert user & request again
                if (passwordCheckResult == "invalid") { 
                    
                    console.log("Password incorrect");
                    $(".username-unavailable-offchain").hide(300); 
                    $(".password-invalid-offchain").show(300); // alert
                    setErrorUsername(true);
                    setErrorUserPassword(true);
                    setPasswordFieldVisible(true);
                    return "invalid";

                } else { // If password is VALID
                    return "valid";
                }

            } else { // If password NOT entered...

                console.log("handlePassword - Password not entered");
                $(".password-invalid-offchain").hide(300); 
                $(".username-unavailable-offchain").show(300); // alert
                setErrorUsername(true);
                setErrorUserPassword(true);
                setPasswordFieldVisible(true);
                return "invalid";
            }
        }

    // Verify user's identity, get email address, and display in input field

        async function verifyUserAndGetEmail() { 
            // Get user blockchain address
			const bchain_account = await requestAccount();
            console.log("Check bchain_account: " + bchain_account);
            setUserAddr(bchain_account);
            $('.alert-area').hide();

            authenticateUserAndGetInfoFromDB(bchain_account).then((result) => {
                console.log("Check result: ", result);
                if (result !== 'error') {
                    if (result !== 'unauthorized') {
                        console.log("User found in DB");
                        $('#user-email-field').val(result['email']);
                        // setEmailInputIsDisabled(false);
                        setInputIsDisabled(false); // added 6/14
                        setUserEmail(result['email']);
                        setUserEmail_tb_state(result['email']);
                        setUserEmailLabel('');
                        $('#show-verify-button').hide();
                        $('#save-button').show();
                    } else {
                        console.log("User not found in DB");
                        $('#user-email-field').val('');
                        // setEmailInputIsDisabled(true);
                        setInputIsDisabled(true); // added 6/14
                        setUserEmail(null);
                        setUserEmail_tb_state('[email hidden]');
                        $('#user-email-field').val('[email hidden]');
                        // $('.registered-user-edit').hide();
                        $('.alert-area').hide();
                        switchAlert('user-authentification-failed');
                    }
                }
            })
        };


    // Verify user's identity, check input fields, and save to DB

	async function verifyUserCheckInputAndSave() { // "PrepareAndExecuteBchainTx"

		// preparation
			console.log("========================");
			console.log('username_state: ' + username_state);
			console.log('userEmail_state: ' + userEmail_state);
			$(".username-unavailable").hide(300);
            $(".user-email-unavailable").hide(300);
            $('.user-authentification-failed').hide();
            resetAllPasswordAlerts();

		// Get user blockchain address
			const bchain_account = await requestAccount();
            console.log("Check bchain_account: " + bchain_account);
            setUserAddr(bchain_account);

		// Check user's info (get blockchain address & username if needed)
            const arrayFromBchainDB = await authenticateUserAndGetInfoFromDB(bchain_account);
            if (arrayFromBchainDB !== 'error') {
                if (arrayFromBchainDB === 'unauthorized') {
                    $('.alert-area').hide();
                    switchAlert('user-authentification-failed');
                    return;
                }
            } else {
                alert("Error!")
                return;
            }
            console.log("Check arrayFromBchainDB: ", arrayFromBchainDB);

        let finalVersionNum = 1;
        let updateType = 'original';
        let DBUpdateResult;

		// Check user input fields and send to DB
			const inputCheck = await checkInputFields();
			console.log("Check inputCheck: ", inputCheck);

			// Alert user if any field left empty
			if (inputCheck['valid'] == false) {
                console.log("Input field(s) empty");
				window.scrollTo({ top: 0, behavior: 'smooth' });
				return // stop function / prevent txn

			// If all fields filled...
			} else if (inputCheck['valid'] == true) {

				// Check availability of username & email input (DB)
                    const arrayFromNameDB = await getUserInfoFromDB(username_state, 'username');
                    const arrayFromEmailDB = await getUserInfoFromDB(userEmail_state, 'email');
                    const arrayFromNameDB_offchain = await getUserInfoFromDB_offchain(username_state, 'username');

                    $('.alert-area').hide(300); // reset
                    let check1 = false; let check2 = false; let check3 = false;

                    if (arrayFromBchainDB === 'none') { // If user (blockchain) not yet registered...

                        if (arrayFromNameDB !== 'none') { // If username already TAKEN (existing in onchain-users DB)...
                            $(".username-unavailable").show(300); // alert
                            setErrorUsername(true);
                            check1 = true;
                        }

                        if (arrayFromEmailDB !== 'none') { // If email already TAKEN (existing in onchain-users DB)...
                            $(".user-email-unavailable").show(300); // alert
                            setErrorUserEmail(true);
                            check2 = true;
                        }

                        if ((check1 == false && check2 == false) && arrayFromNameDB_offchain !== 'none') { // If username already TAKEN (existing OFFchain-users DB)...

                            const passwordCheckResult = await handlePassword();
                            if (passwordCheckResult == "invalid") {
                                check3 = true;
                            }

                        } else { // Reset password 

                            setUserPassword(null);
                            // setUserPassword(null);
                        }

                        if (check1 == true || check2 == true || check3 == true) {
                            return; // Stop process if either/both already exist in DB
                        }

                    } else { // If user (blockchain) already registered...

                        let usernameChanged = false; let emailChanged = false; let usernameFound = false; let emailFound = false;

                        // Check if username changed
                        if (username_state !== arrayFromBchainDB['username']) {
                            console.log("Username changed");
                            usernameChanged = true;
                            // If changed...
                                // See if new username already exists in ONchain users DB...
                                if (arrayFromNameDB !== 'none' && username_state !== arrayFromBchainDB['username']) {
                                    $(".username-unavailable").show(300);
                                    setErrorUsername(true);
                                    console.log("Username already exists in DB");
                                    return; // Stop txn if username already exists in DB
                                }
                                // See if new username already exists in OFFchain users DB...
                                if (arrayFromNameDB_offchain !== 'none') {
                                    const passwordCheck_2_Result = await handlePassword();
                                    if (passwordCheck_2_Result == "invalid") {
                                        return;
                                    }
                                }
                        }
                        // Check if email changed
                        if (userEmail_state !== arrayFromBchainDB['email']) {
                            console.log("Email changed");
                            emailChanged = true;
                            // If changed, see if new email already exists in DB...
                            if (arrayFromEmailDB !== 'none' && userEmail_state !== arrayFromBchainDB['email']) {
                                $(".user-email-unavailable").show(300);
                                setErrorUserEmail(true);
                                console.log("Email already exists in DB");
                                return; // Stop txn if email already exists in DB
                            }
                        }

                        // If both unchanged, stop txn
                        console.log("Check usernameChanged: " + usernameChanged);
                        console.log("Check emailChanged: " + emailChanged);
                        if (usernameChanged == false && emailChanged == false) {
                            console.log("Username and email unchanged");
                            alert('No changes detected');
                            return;
                        } else { // If either/both changed, increase version number and change update type
                            console.log("Username and/or email changed");
                            finalVersionNum = Number(arrayFromBchainDB['version_num']) + 1;
                            updateType = 'update';
                        }
                    }

				// If all good, insert user/owner into into user registry DB
                    DBUpdateResult = await insertUserInfo(updateType, username_state, bchain_account, userEmail_state, finalVersionNum); 
                    console.log("DBUpdateResult: ", DBUpdateResult);
                    if (DBUpdateResult === 'success') {
                        $('.user-info-fields').hide();
                        $('.alert-area').hide();
                        $('.success-message').show(300);
                        $('.id-table').show(300);
                        $('.blockchain-button').hide();
                        $('.hor-line').hide();
                        setEnableTableEdit(true);
                        setUsername(username_state);
                        setUserEmail(userEmail_state);
                        setUsername_tb_state(username_state);
                        setUserEmail_tb_state(userEmail_state);
                    }
			}

	} // end of verifyUserCheckInputAndSave


    // Prepare texts
        let newTabOpenImg = ASSETS_FOLDER + 'ext-link-icon.png';
        const infoBlockchain = "To register yourself as a user, you need a cyrpto/Web3 wallet installed on your browser or use a wallet app on your mobile device. Then with this wallet you can 1) connect to blockchain, 2) store information onchain, and 3) pay a tiny transaction fee. (Reading from blockchain is free, writing to it is not, though it's so cheap it's practically free.) <br/><br/>If you are new to blockchain and worry that connecting a wallet (Web3 equivalent of 'log in') sounds unsafe, <a href='./faq' target='_blank'>please see FAQ</a> <img src=" + newTabOpenImg + " width='17px'> for more information. Being careful is wise but there's no need to be overly paranoid. <br/><br/>Note: If you already have a wallet with a lot of assets in it, you can create a separate account inside your wallet and use it with Psiscope if you want to feel extra safe.";

    // Help info show/hide
        const [bchainInfo, setBchainInfo] = React.useState(false);

    // Blockchain help info show/hide 
        const HandleBchainInfoClick = () => { 

            if (bchainInfo == false) {
                setBchainInfo(true);
                $('#blockchain-help-info').html('');
                $('#blockchain-help-info').append(infoBlockchain);
                $('#blockchain-help-info').show(200);
				$([document.documentElement, document.body]).animate({
					scrollTop: $("#blockchain-help-info").offset().top -150
				}, 500);
            } else {
                setBchainInfo(false);
                $('#blockchain-help-info').hide(400);
                $('#blockchain-help-info').html('');
            }
        };

    // Set entered addresses
      const handleAddressBoxTextChange = (event) => {
        // const newText = event.target.value.replace(/\n/g, '<br/>');
        const newText = event.target.value;
        // console.log('Entered addresses: ' + newText);
      }; 

    // For table
        let userAddress_tb = userAddress_state;
        let username_tb = username_tb_state;
        let userEmail_tb = userEmail_tb_state;
        if (userAddress_state === null) { userAddress_tb = '[blockchain address]'; }
        if (username_tb_state === null) { username_tb = '[username]'; }
        if (userEmail_tb_state === null) { userEmail_tb = '[email address]'; }

        const primaryArray = [userAddress_tb, username_tb, userEmail_tb];
        const secondaryArray = ['Blockchain Address', 'Username', 'Email Address'];
        
        const IdTable = styled('div')(({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
        }));

    // -----

    // Set dark theme
        const darkTheme = createTheme({
          palette: {
            mode: 'dark',
          },
        });

	// Set dim theme
		const dimtheme = createTheme({
			palette: {
				neutral: {
					main: 'rgb(171, 171, 171)',
					contrastText: '#fff',
				},
			},
		});


    ///////////////

    return (

        <div className="App-container">

            <React.Fragment>
              <ThemeProvider theme={darkTheme}>
              <CssBaseline />
              <Container maxWidth="md" style={{ border: "0px solid red"}}>

			{/* Mobile Nav Buttons*/}

				<div className="mobile-nav-buttons" style={{border:"0px solid red", margin:"auto", marginTop:"-15px", display:"none"}}>

                    <Button size="small" sx={{ my: 2 }} style={{ marginLeft:"5px", marginRight:'3px', marginTop:'17px'}} onClick={ () => handleNavbarResetClick() } >
                        <div className="nav-menu-mobile" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>RESET</div>
                    </Button>

                    <div style={{ color:'gray', display:'inline-block' }}>|</div>

                    <Button size="small" sx={{ my: 2 }} style={{ marginLeft:"-7px", marginTop:'17px'}}>
                        <a href={FAQ_URL} target="_blank" rel="noopener noreferrer" className="nav-menu-mobile" style={{ fontSize:'16px', fontWeight:'normal', color:'white', textDecoration: 'none' }}>FAQ</a>
                    </Button>
                </div>

                <div className="app-title" style={{ margin:"13px 0px 2px" }}>
                    ACCOUNT MANAGER
                </div>

                <br/><br/>


                {/* gray box */}

				<div className='address-input-section' style={{ margin:"auto", marginBottom:"-20px", maxWidth:'660px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025)', padding:'15px', paddingTop:'35px', paddingBottom:'130px' }}>

                {/* Create/Edit Group label */}

                <div className='subheading register-edit-intro-mode' style={{ marginBottom:'7px' }}>REGISTER / EDIT</div>

				<div className='subheading register-mode' style={{ marginBottom:'7px', display:'none' }}>R E G I S T E R</div>

                <div className='subheading update-mode' style={{ marginBottom:'7px', display:'none' }}>U P D A T E</div>

                <Box
                  className='user-info-required user-info-fields'
                  style={{ margin:'30px 0px 0px', display:'block'}}
                  component="form"
                  sx={{
                    '& > :not(style)': { m: 1, width: '27ch' },
                  }}
                  noValidate
                  autoComplete="off"
                >
                    <TextField 
                        id="user-name-field" 
                        disabled={inputIsDisabled}
                        placeholder={usernameLabel_state}
                        label={usernameLabel_state}
                        helperText="Choose your public username"
                        variant="standard" 
                        error={errorUsername} 
                        onChange={(event) => {setUsername(event.target.value)}} 
                    />

                    <TextField 
                        id="user-email-field"
                        disabled ={inputIsDisabled}
                        placeholder={userEmailLabel_state}
                        label={userEmailLabel_state}
                        helperText="This will be kept OFF-chain and private"
                        variant="standard" 
                        error={errorUserEmail} 
                        onChange={(event) => {setUserEmail(event.target.value)}} 
                    />

                    {passwordFieldVisible && (
                        <TextField 
                            id="user-password-field"
                            disabled ={inputIsDisabled}
                            label={userPasswordLabel_state}
                            helperText="Password for your off-chain account"
                            variant="standard" 
                            error={errorUserPassword} 
                            onChange={(event) => {setUserPassword(event.target.value)}} 
                        />
                    )}

                    <br/><br/>
                </Box>

                {/* Alerts * * * */}

                    <center>

                    <div className='connect-blockchain alert-area' style={{ margin:'20px 0px 0px', maxWidth:'500px', color:'rgb(139, 214, 167)', fontSize:'16px', fontWeight:'normal', display:'none'}}>Please connect to bockchain</div>

                    <div className='swtich-network alert-area' style={{ margin:'20px 0px 0px', maxWidth:'500px', color:'rgb(139, 214, 167)', fontSize:'16px', fontWeight:'normal', display:'none'}}>Please switch network to Base <br/>(click button)</div>

                    <div className='user-authentification-failed alert-area' style={{ margin:'0px 0px 20px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>Your blockchain address could not be authenticated. Please try again or contact support.</div>

                    <div className='registered-user-edit alert-area' style={{ margin:'0px 0px 20px', maxWidth:'500px', color:'lightgreen', fontSize:'15px', display:'none'}}>You're registered. To update information please verify your identity first.</div>

                    <div className='new-user alert-area' style={{ margin:'0px 0px 20px', maxWidth:'420px', color:'rgb(255, 201, 201)', fontSize:'15px', display:'none'}}>
                        <div style={{marginBottom:'7px', color:'rgb(161, 161, 161)', overflowWrap:'break-word'}}>
                            Your address:<br/>
                            {userAddress_state}
                        </div>
                        <div>
                            Address unrecognized. Please register if you're a new user. (Email will be kept off-chain & private.)
                        </div>
                    </div>

                    <div className='username-unavailable alert-area' style={{ margin:'0px 0px 20px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>This username is taken! Please choose a different name.</div>

                    <div className='user-email-unavailable alert-area' style={{ margin:'0px 0px 20px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>This email address is taken! Please use a different one.</div>

                    <div className='success-message alert-area' style={{ margin:'30px 0px 20px', maxWidth:'500px', color:'lightgreen', fontSize:'18px', fontWeight:'bold', display:'none'}}>Successfully Saved!</div>

                    <div className='username-unavailable-offchain alert-area' style={{ margin:'0px 0px 20px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>This username belongs to an off-chain user. If it is you, please enter a password for it to continue. Otherwise, please choose a different name.</div>

                    <div className='password-invalid-offchain alert-area' style={{ margin:'0px 0px 20px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>The password you entered was incorrect. Please enter a correct password or choose a different username.</div>

                    
                {/* ID Table */}
                    
                    <Grid className='id-table' container spacing={2} style={{ marginTop:'10px', display:'none'}}>
                        <Grid item xs={12} sm={8} md={8} style={{ margin:'auto'}}>
                            <IdTable>
                                <List dense={dense}>
                                {primaryArray.map((value, index) => (
                                    <ListItem style={{overflowWrap:'break-word'}} key={value}>
                                        <ListItemText 
                                            primary={value}
                                            secondary={secondaryArray[index]} 
                                        />
                                    </ListItem>
                                ))}
                                </List>
                            </IdTable>
                        </Grid>
                    </Grid>

                    </center>

                {/* Horizontal divider */}
                  <center>
                    <div className='hor-line width-control-1' style={{margin: 'auto', margin: '45px 0px 0px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '500px'}}></div>
                  </center>


                </div> {/* end of gray box  */}

              </Container>
              </ThemeProvider>
            </React.Fragment>


            <ThemeProvider theme={darkTheme}>

            <center>
            {/* save button area */}
            <div className='blockchain-button address-input-section' style={{margin:'-100px 0px 25px', border:'0px solid red'}}>

                <div id='vertical-adj-3' style={{display: 'none'}}></div>

                <Button id='show-verify-button' variant='contained' style={{fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ sendButtonDisabled } onClick={verifyUserAndGetEmail}>
                    Step 1: Verify Identity
                </Button>

                <Button id='save-button' variant='contained' style={{fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ sendButtonDisabled } onClick={verifyUserCheckInputAndSave}>
                    Click To Save
                </Button>

                <Button id='connect-wallet-button' variant='contained' style={{backgroundColor: 'rgb(207, 154, 151)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ sendButtonDisabled } onClick={connectWallet}>
                    Connect Wallet
                </Button>

                <Button id='switch-chain-button' variant='contained' style={{backgroundColor: 'rgb(239, 223, 143)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ sendButtonDisabled } onClick={handleSwitchNetwork}>
                    Switch Network
                </Button>

                <Box id='bchain-progress' style={{display: 'none'}}>
                  <CircularProgress />
                </Box>

                {/* Blockchain help text */} 

                  <div className="bchain-help-section" style={{ marginTop:'-5px', display:"block"}}>

                    <HelpOutline 
                        className = "width-control-1 width-control-2"
                        onClick={HandleBchainInfoClick}
                        sx={{
                          '& > :not(style)': { m: 0 },
                          color: "lightblue",
                          width: 300, // 30
                          maxWidth: '100%',
                          margin: "auto",
                          // marginTop: "-17x",
                          marginBottom: "-23px",
                          marginLeft: "91px",
                          fontSize: "20px",
                          border: "0px solid green",
                        }} 
                    /> 

                    <div style={{ border:"0px solid red", maxWidth: '405px', margin: 'auto', color: 'rgb(200, 200, 200)', fontSize:"15px" }}>
                      <center style={{ marginTop:"-4px", marginLeft:"-21px"}}>
                        What is this?
                      </center>
                    </div>

                    <div id='blockchain-help-info' style={{border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025)', margin: 'auto', marginTop: '48px', maxWidth: '650px', padding:'18px', color: 'rgb(235, 235, 235)', fontSize: '16px', lineHeight:'1.8', textAlign: 'left', display: 'none'}}></div>

                  </div>
                {/* end blockchain help text */}

            </div> {/* End of save button area */}
            </center>


            </ThemeProvider>

            <br/><br/><br/><br/>

        </div>
    );

}


export default App;
